export enum CheckStyleKind {
  Check = 0,
  Fill = 2,
}
